var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.793 14.7787V17.7746C19.793 19.3094 16.8289 20.5536 13.1725 20.5536C9.51603 20.5536 6.55191 19.3094 6.55191 17.7746V16.3673M3.68066 10.9504V13.9463C3.68066 15.4811 6.64479 16.7253 10.3012 16.7253C13.9577 16.7253 16.9218 15.4811 16.9218 13.9463V10.9504M6.55191 5.20792V8.20381C6.55191 9.73859 9.51603 10.9828 13.1725 10.9828C16.8289 10.9828 19.793 9.73859 19.793 8.20381V5.20792M6.55191 8.78433C4.81765 9.28541 3.68066 10.1245 3.68066 11.075C3.68066 12.6098 6.64479 13.854 10.3012 13.854C13.9577 13.854 16.9218 12.6098 16.9218 11.075C16.9218 10.9527 16.9029 10.8322 16.8664 10.714M16.4225 12.4817C18.4346 12.9585 19.793 13.8644 19.793 14.9034C19.793 16.4382 16.8289 17.6823 13.1725 17.6823C11.0978 17.6823 9.24596 17.2818 8.03206 16.6548C7.89269 16.5828 7.82719 16.5812 7.70526 16.5035M11.0781 6.19115L10.8185 5.20792L15.0772 5.20572L14.8061 4.22028L15.3484 6.19115M19.793 5.33256C19.793 6.86735 16.8289 8.11154 13.1725 8.11154C9.51603 8.11154 6.55191 6.86735 6.55191 5.33256C6.55191 3.79778 9.51603 2.55359 13.1725 2.55359C16.8289 2.55359 19.793 3.79778 19.793 5.33256Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.2f6e879197ca807498895973119b9cb6.svg";
export { ForwardRef as ReactComponent };